import styles from "./OrderSummary.module.css";
import { Link } from "react-router-dom";
import CartProduct from "../../cartProduct/CartProduct";

function OrderSummary({ cart, shippingRate = null, shippingRateStatus = "idle", taxAmount = 0 }) {
    const normalizeShippingAmount = (value) => {
        const numericValue = Number(value);

        if (!Number.isFinite(numericValue)) {
            return 0;
        }

        return numericValue > 1000 ? numericValue / 100 : numericValue;
    };

    const effectiveShippingRate = normalizeShippingAmount(
        shippingRate ?? cart?.shipping_cents ?? 0
    );
    const shippingRateLoading = shippingRateStatus === "loading";
    const shippingRateFailed = shippingRateStatus === "error";
    const effectiveTaxAmount = Number.isFinite(Number(taxAmount))
        ? Number(taxAmount)
        : Number(cart?.tax_cents ?? 0) / 100;

    const renderLoadingValue = (label) => (
        <span className={styles.loadingValue} role="status" aria-label={label}>
            <span className={styles.spinner} aria-hidden="true" />
        </span>
    );

    if (!cart || !cart.items || cart.items.length === 0) {
        return (
            <div className={styles.emptyCart}>
                <p>Your cart is empty.</p>
                <Link to="/onlineStore" className={styles.continueShoppingButton}>
                    Continue Shopping
                </Link>
            </div>
        );
    }

    const cartProductStyles = {
        container: {
            padding: "0",
            border: "none",
            gridTemplateColumns: "96px minmax(0, 1fr)",
            alignItems: "start"
        },
        name: {
            fontSize: "var(--font-md)"
        },
        description: {
            fontSize: "var(--font-xs)",
            display: "block",
            overflow: "visible",
            WebkitLineClamp: "unset",
            lineClamp: "unset"
        },
        footer: {
            marginTop: "var(--space-2)"
        },
        quantityButton: {
            display: "none"
        },
        quantity: {
            fontSize: "var(--font-xs)"
        },
        price: {
            fontSize: "var(--font-sm)"
        },
        deleteButton: {
            display: "none"
        }
    }
// id: 20
// price: 3999
// product_variant: 
//     id: 1
//     price_cents: 3999
//     product: 
//         description: "High-performance pre-workout powder designed for energy, focus, and endurance."
//         id: 1
//         image: "https://cdn.example.com/products/preworkout/blue-front.jpg"
//         name: "IQ Pre-Workout"
    return (
        <div className={styles.orderSummary}>
            <div className={styles.cartProductList}>
                <ul className={styles.cartProductListScroll}>
                    {cart.items.map((item) => (
                            <CartProduct 
                                key={item.id} 
                                item={item} 
                                cartProductStyles={cartProductStyles}
                            />
                    ))}
                </ul>
            </div>
            <div className={styles.totals}>
                <div className={styles.totalRow}>
                    <span>Sub Total:</span>
                    <span>${cart.subtotal_cents / 100}</span>
                </div>
                <div className={styles.totalRow}>
                    <span>Shipping:</span> 
                    {shippingRateLoading
                        ? renderLoadingValue("Calculating shipping")
                        : <span>{shippingRateFailed ? "—" : `$${effectiveShippingRate.toFixed(2)}`}</span>}
                </div>
                <div className={styles.totalRow}>
                    <span>Tax:</span>
                    <span>${effectiveTaxAmount.toFixed(2)}</span>
                </div>
                <div className={styles.totalRow}>
                    <span>Total:</span>
                    {shippingRateLoading
                        ? renderLoadingValue("Calculating total")
                        : <span>{shippingRateFailed ? "—" : `$${((cart.subtotal_cents || 0) / 100 + effectiveShippingRate + effectiveTaxAmount).toFixed(2)}`}</span>}
                </div>
            </div>

        </div>
    );
}

export default OrderSummary;